// Search bar constants
export const SEARCH_BAR_CONSTANTS = {
  DEFAULT_WIDTH: '200px',
  MIN_WIDTH: 120,
  MAX_WIDTH: 400,
  PADDING_OFFSET: 20,
  MIN_DRAGGABLE_WIDTH: 50,
  PLACEHOLDER_TEXT: 'Flik search',
};

// Window constants (not used in web but needed for compatibility)
export const WINDOW_CONSTANTS = {
  WIDTH: 400,
  HEIGHT_COLLAPSED: 60,
  HEIGHT_EXPANDED: 400,
  HEIGHT_SIGNIN: 200,
  HEIGHT_COLLAPSED_WITH_QUICK_ACTIONS: 100,
  WIDTH_WITH_CONTENT: 500,
  HEIGHT_WITH_CONTENT: 500,
  WIDTH_HEADER_ONLY: 400,
  HEIGHT_HEADER_ONLY: 60,
};
